import React, { useCallback, useEffect, useState } from 'react'
import dbApp from "./firebase"
export const AuthContext = React.createContext()

export const AuthProvider = ({ children }) => {
	const [currentUser, setCurrentUser] = useState(null)
	const [pending, setPending] = useState(true);
	const loadingStyle = {
		margin: 'auto',
		width: '50%',
		padding: '10px',
	}

	const updateCurrentUser = useCallback(async (user, forceRefresh = false) => {
		if (!user) {
			setCurrentUser(null)
			return null
		}

		const idTokenResult = await user.getIdTokenResult(forceRefresh)
		setCurrentUser(idTokenResult.claims)
		return idTokenResult.claims
	}, [])

	const refreshCurrentUser = useCallback(async () => {
		const user = dbApp.auth().currentUser
		return updateCurrentUser(user, true)
	}, [updateCurrentUser])

	useEffect(() => {
		const unsubscribe = dbApp.auth().onIdTokenChanged(async (user) => {
			try {
				let claims = await updateCurrentUser(user)
				if (user && claims && !claims.companyId && (claims.rol === 'admin' || claims.email === 'admin@admin.com')) {
					const initializeCompany = dbApp.functions('us-central1').httpsCallable('initializeCompany')
					await initializeCompany({})
					await updateCurrentUser(user, true)
				}
			} catch (error) {
				console.error('No fue posible actualizar la sesión', error)
				setCurrentUser(null)
			} finally {
				setPending(false)
			}
		})

		return unsubscribe
	}, [updateCurrentUser]);
	if (pending) {
		return <h1 style={loadingStyle}>Cargando...</h1>
	}

	return (
		<AuthContext.Provider value={{ currentUser, refreshCurrentUser }} >
			{children}
		</AuthContext.Provider>
	);
};
